module.exports = __webpack_public_path__ + "img/elitacop.2e9d57cd.png";